export const TEAM_MEMBERS = 'TEAM_MEMBERS'
export const TEAM_MEMBERS_STATUS = 'TEAM_MEMBERS_STATUS'
export const DELETE_MEMBER = 'DELETE_MEMBER'
export const DELETE_MEMBER_STATUS = 'DELETE_MEMBER_STATUS'
export const DELETE_INVITATION = 'DELETE_INVITATION'
export const DELETE_INVITATION_STATUS = 'DELETE_INVITATION_STATUS'
export const RE_INVITE = 'RE_INVITE'
export const RE_INVITE_STATUS = 'RE_INVITE_STATUS'
